"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constant = require("../constant");
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Button = _interopRequireDefault(require("../Button"));
var _LoginTooltip = _interopRequireDefault(require("./LoginTooltip.proptypes"));
var _constants = require("./constants");
var _constant2 = require("../JourneyPriceCTA/constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LoginToolTipContainer = _styledComponents.default.div.withConfig({
  displayName: "LoginTooltip__LoginToolTipContainer",
  componentId: "sc-166hj1m-0"
})(["min-width:", ";background:", ";margin:auto;box-shadow:0px 1px 4px rgba(0,0,0,0.16);border-radius:", ";box-sizing:border-box;padding:", ";position:", ";z-index:", ";", " ", ""], function (_ref) {
  var viewport = _ref.viewport;
  return viewport === _constant.DEVICE_TYPE.DESKTOP ? _constants.DEFAULT_STYLES.DEFAULT_MIN_WIDTH_DESKTOP : _constants.DEFAULT_STYLES.DEFAULT_MIN_WIDTH;
}, function (props) {
  return props.theme.backgroundColor[props.background];
}, function (_ref2) {
  var theme = _ref2.theme,
    move = _ref2.move;
  return move ? theme.borderRadius.medium : theme.borderRadius.normal;
}, function (_ref3) {
  var theme = _ref3.theme,
    viewport = _ref3.viewport;
  return viewport === _constant.DEVICE_TYPE.DESKTOP ? theme.space.semi : theme.space.small;
}, function (_ref4) {
  var position = _ref4.position;
  return position;
}, function (_ref5) {
  var position = _ref5.position;
  return position === _constants.POSITION.absolute ? 4 : 'unset';
}, function (_ref6) {
  var disp = _ref6.disp;
  return !disp && "display: none;";
}, function (_ref7) {
  var align = _ref7.align;
  return align === _constants.ALIGN.CENTER ? (0, _styledComponents.css)(["left:50%;transform:translateX(-50%);"]) : align === _constants.ALIGN.RIGHT && "\n        right: 0;\n    ";
});
var CTAButtonSection = _styledComponents.default.div.withConfig({
  displayName: "LoginTooltip__CTAButtonSection",
  componentId: "sc-166hj1m-1"
})(["display:flex;justify-content:space-around;"]);
var LoginTooltip = function LoginTooltip(props) {
  var theme = props.theme,
    accessible = props.accessible,
    customProperties = props.customProperties,
    show = props.show,
    data = props.data,
    backgroundColor = props.backgroundColor,
    titleColor = props.titleColor,
    descriptionColor = props.descriptionColor,
    hideSignup = props.hideSignup,
    position = props.position,
    align = props.align,
    viewport = props.viewport;
  var title = data.title,
    description = data.description,
    loginButtonText = data.loginButtonText,
    signupButtonText = data.signupButtonText;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(show),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    displayTooltip = _useState2[0],
    setDisplayTooltip = _useState2[1];
  var hideToolTip = (0, _react.useCallback)(function (event) {
    if (typeof window !== 'undefined') {
      var toolTipId = document.getElementById('login-tooltip');
      var signup = document.getElementById('signup-tooltip-button');
      var login = document.getElementById('login-tooltip-button');
      if (event.target !== signup && event.target !== login && event.target !== toolTipId && event.target.parentNode !== toolTipId) {
        setDisplayTooltip(false);
        var evt = new CustomEvent('tooltipClosed', {
          detail: true
        });
        window.dispatchEvent(evt);
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    // Hide the component by default after 60 seconds
    var timeout;
    if (!position || position && position === _constants.POSITION.absolute) {
      if (show) {
        timeout = setTimeout(function () {
          setDisplayTooltip(false);
        }, 60000);
      }
    }
    setDisplayTooltip(show);
    return function () {
      if (!position || position && position === _constants.POSITION.absolute) {
        clearTimeout(timeout);
      }
    };
  }, [show, position]);
  (0, _react.useEffect)(function () {
    if (displayTooltip && typeof window !== 'undefined') {
      var evt = new CustomEvent('tooltipOpened', {
        detail: true
      });
      window.dispatchEvent(evt);
    }
  }, [displayTooltip]);
  (0, _react.useEffect)(function () {
    if (!position || position && position === _constants.POSITION.absolute) {
      if (typeof window !== 'undefined') {
        window.addEventListener('mouseup', function (event) {
          return hideToolTip(event);
        });
        window.addEventListener('keydown', function (event) {
          return hideToolTip(event);
        });
      }
    }
    return function () {
      if (!position || position && position === _constants.POSITION.absolute) {
        if (typeof window !== 'undefined') {
          window.removeEventListener('mouseup', function (event) {
            return hideToolTip(event);
          });
          window.removeEventListener('keydown', function (event) {
            return hideToolTip(event);
          });
        }
      }
    };
  }, [hideToolTip, position]);
  var loginClicked = function loginClicked() {
    var evtClicked = new CustomEvent('loginClicked', {
      detail: true
    });
    window.dispatchEvent(evtClicked);
  };
  var handleSignUpClick = function handleSignUpClick(event) {
    event.preventDefault();
    loginClicked();
    var evt = new CustomEvent('openLogin', {
      detail: true
    });
    window.dispatchEvent(evt);
  };
  var handleLoginClick = function handleLoginClick(event) {
    event.preventDefault();
    loginClicked();
    var evt = new CustomEvent('openLogin', {
      detail: true
    });
    window.dispatchEvent(evt);
  };
  var getMain = function getMain() {
    var pos = !position || position && position === _constants.POSITION.absolute ? _constants.POSITION.absolute : _constants.POSITION.relative;
    var move = theme === _constant2.THEMES.MOVE;
    return /*#__PURE__*/_react.default.createElement(LoginToolTipContainer, (0, _extends2.default)({
      id: "login-tooltip",
      disp: displayTooltip,
      tabIndex: tabIndex,
      background: backgroundColor,
      position: pos,
      align: align,
      viewport: viewport,
      move: move
    }, customProperties), title && title.length > 0 && /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "block",
      color: titleColor,
      textAlign: "center",
      type: "default",
      marginBottom: "tiny",
      bold: true,
      customProperties: {
        id: 'tooltip-title'
      }
    }, title),
    // eslint-disable-next-line react/prop-types
    description && description.length > 0 && /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "block",
      color: descriptionColor,
      textAlign: "center",
      type: "sub",
      marginBottom: "standard",
      bold: false,
      customProperties: {
        id: 'tooltip-description'
      }
    }, description), /*#__PURE__*/_react.default.createElement(CTAButtonSection, null, !hideSignup && signupButtonText && signupButtonText.length > 0 && /*#__PURE__*/_react.default.createElement(_Button.default, {
      handleClick: handleSignUpClick,
      accessible: accessible,
      backgroundColor: "default",
      color: move ? 'secondary' : 'primary',
      width: "120px",
      target: "tab",
      customProperties: {
        id: 'signup-tooltip-button'
      },
      margin: ['none', 'tiny', 'none', 'none'],
      border: "primary",
      boxShadow: false,
      borderColor: move && '#023C40'
    }, signupButtonText), loginButtonText && /*#__PURE__*/_react.default.createElement(_Button.default, {
      handleClick: handleLoginClick,
      accessible: accessible,
      backgroundColor: "primary",
      color: move ? 'secondary' : 'default',
      width: !hideSignup && signupButtonText ? '120px' : '100%',
      target: "tab",
      customProperties: {
        id: 'login-tooltip-button'
      },
      margin: ['none', 'none', 'none', "".concat(!hideSignup && signupButtonText ? 'tiny' : 'none')],
      border: "primary",
      boxShadow: false,
      borderColor: move && '#023C40'
    }, loginButtonText)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
LoginTooltip.propTypes = _LoginTooltip.default.PropTypes;
LoginTooltip.defaultProps = _LoginTooltip.default.DefaultProps;
var _default = LoginTooltip;
exports.default = _default;